"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M47.9 24.6c0-11.751-8.365-21.311-18.722-21.311S10.855 12.249 10.456 23.4H.1c0 11.751 8.365 21.311 18.722 21.311s18.323-8.96 18.721-20.111zm-19.12-1.2c2.191-5.178 4.382-7.17 7.967-7.17a7.14 7.14 0 0 1 7.17 7.17zm.4-18.921c7.967 0 14.738 6.174 16.73 14.539a9.885 9.885 0 0 0-9.162-5.776c-6.573 0-9.361 5.178-11.153 10.157H11.651c.6-10.556 8.166-18.921 17.527-18.921zM25.195 24.6c-1.595 3.383-5.179 10.155-11.552 10.155-5.577 0-9.56-3.983-9.759-10.158zm-6.374 18.918A17.482 17.482 0 0 1 3.087 32.365a11.961 11.961 0 0 0 10.556 5.378c6.174 0 11.751-4.979 14.738-13.145h7.967c-.398 10.555-8.166 18.92-17.527 18.92z" })
);

